module.exports = __webpack_public_path__ + "img/huace7.3a273c86.jpg";